import { GameState } from '../StateManager';
import { Game } from '../Game';
import { COLORS } from '../config/settings';

export class GameOverState implements GameState {
  private game: Game;
  private finalScore: number = 0;
  private isVictory: boolean = false;
  private animTimer: number = 0;
  private buttonRect: { x: number; y: number; w: number; h: number } | null = null;

  constructor(game: Game) {
    this.game = game;
  }

  public enter(): void {
    console.log('Game Over');
    // Score and victory status would be passed from PlayState
  }

  public enterWithData(data: { victory: boolean; score: number }): void {
    this.setVictory(data.victory);
    this.setScore(data.score);
    this.enter();
  }

  public exit(): void {
    console.log('Exited Game Over State');
  }

  public setScore(score: number): void {
    this.finalScore = score;
  }

  public setVictory(victory: boolean): void {
    this.isVictory = victory;
  }

  public update(deltaTime: number): void {
    this.animTimer += deltaTime;

    const input = this.game.getInput();

    // Handle keyboard fallback (still allowed but not shown on screen)
    if (input.enter || input.fire) {
      this.game.getStateManager().changeState('play');
      return;
    }

    // Handle click / touch for the Play + Listen button
    const click = input.getClick();
    if (click && this.buttonRect) {
      const { x, y } = click;
      const r = this.buttonRect;
      if (x >= r.x && x <= r.x + r.w && y >= r.y && y <= r.y + r.h) {
        // Start music (user interaction required by browsers) and go to play
        try {
          this.game.getAudioManager().play();
        } catch (e) {
          // ignore play errors
        }
        this.game.getStateManager().changeState('play');
      }
    }
  }

  public render(ctx: CanvasRenderingContext2D): void {
    const renderer = this.game.getRenderer();
    renderer.clear('#0a0a0f');

    const centerX = renderer.width / 2;
    const centerY = renderer.height / 2;

    if (this.isVictory) {
      // Victory screen
      ctx.font = 'bold 48px "Courier New"';
      ctx.fillStyle = COLORS.SUCCESS;
      ctx.textAlign = 'center';
      ctx.fillText('VICTORY!', centerX, centerY - 100);

      ctx.font = '20px "Courier New"';
      ctx.fillStyle = COLORS.TEXT;
      ctx.fillText('The chain is complete!', centerX, centerY - 50);
      ctx.fillText('America is saved!', centerX, centerY - 20);
    } else {
      // Game Over screen
      const pulse = 0.7 + Math.sin(this.animTimer * 2) * 0.3;
      ctx.globalAlpha = pulse;
      ctx.font = 'bold 48px "Courier New"';
      ctx.fillStyle = COLORS.DANGER;
      ctx.textAlign = 'center';
      ctx.fillText('GAME OVER', centerX, centerY - 80);
      ctx.globalAlpha = 1;
    }

    // Final Hands
    ctx.font = 'bold 32px "Courier New"';
    ctx.fillStyle = COLORS.ACCENT;
    ctx.fillText(`Final Hands: ${this.finalScore.toLocaleString()}`, centerX, centerY + 20);

    // Draw Play + Listen button (click/touch target)
    const btnW = 280;
    const btnH = 64;
    const btnX = centerX - btnW / 2;
    const btnY = centerY + 80;
    this.buttonRect = { x: btnX, y: btnY, w: btnW, h: btnH };

    // Button background
    ctx.fillStyle = COLORS.ACCENT;
    ctx.globalAlpha = 1;
    ctx.fillRect(btnX, btnY, btnW, btnH);

    // Button border
    ctx.strokeStyle = COLORS.TEXT;
    ctx.lineWidth = 3;
    ctx.strokeRect(btnX + 1.5, btnY + 1.5, btnW - 3, btnH - 3);

    // Button label
    ctx.font = 'bold 22px "Courier New"';
    ctx.fillStyle = COLORS.BACKGROUND || '#000';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('Play  +  Listen', centerX, btnY + btnH / 2);
    ctx.globalAlpha = 1;
  }
}
